import { HttpAuthInterceptor } from '@qsp-ui-library/services/http-services/http-auth-handler/http-auth-interceptor.service';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  public constructor(private readonly _httpAuthInterceptor: HttpAuthInterceptor) {}

  public intercept<T>(request: Readonly<HttpRequest<T>>, next: Readonly<HttpHandler>): Observable<HttpEvent<T>> {
    const unauthorizedArray = ['/assets/', '/login', '/lab-service-cloud/auth/v2/token'];

    if (!request?.url || unauthorizedArray.some((url: string): boolean => request?.url.includes(url))) {
      return next.handle(request);
    }

    return this._getInterceptor().intercept(request, next);
  }

  private _getInterceptor(): HttpInterceptor {
    return this._httpAuthInterceptor;
  }
}
